import defaultErrorHandler from "actions/global/default-error-handler";

import {
  requestNoPagination,
} from "actions/reports/requests";

import {
  REPORTS_LOADING,
  REPORTS_ERROR,

  REPORTS_GET_LIST,
  REPORTS_GET_LIST_NO_PAGINATION,
  REPORTS_GET_FILTERS,
} from "actions/reports/constants";
import { requestCommonFilters, requestCommonSearch } from "../common/requests";

export const setLoading = status => ({
  type: REPORTS_LOADING,
  payload: status
});

export const getFilters = () => dispatch => {
  dispatch(setLoading(true));
  requestCommonFilters("daily-reports")
    .then((response) => {
      dispatch({
        type: REPORTS_GET_FILTERS,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, REPORTS_ERROR));
    });
};

export const getList = (page = 0, size = 20, sort = "end,desc", filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch("daily-reports", page, size, sort, filters)
    .then(response => {
      dispatch({
        type: REPORTS_GET_LIST,
        payload: response
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, REPORTS_ERROR));
    });
};

export const getNoPagination = (filters = []) => dispatch => {
  dispatch(setLoading(true));
  requestNoPagination(filters)
    .then(response => {
      dispatch({
        type: REPORTS_GET_LIST_NO_PAGINATION,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, REPORTS_ERROR));
    });
};



// WEBPACK FOOTER //
// ./src/actions/reports/actions.js